/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerUpdateMutationRequest, UserControllerUpdateMutationResponse, UserControllerUpdatePathParams, UserControllerUpdateQueryParams, UserControllerUpdate400, UserControllerUpdate401, UserControllerUpdate403, UserControllerUpdate404 } from "../../models/usersController/UserControllerUpdate";

function getUserControllerUpdateUrl(userId: UserControllerUpdatePathParams["userId"]) {
  const res = { method: 'PATCH', url: `/api/v1/users/${userId}` as const }  
  return res
}

/**
 * @summary Update a user
 * {@link /api/v1/users/:userId}
 */
export async function userControllerUpdate(userId: UserControllerUpdatePathParams["userId"], data?: UserControllerUpdateMutationRequest, params?: UserControllerUpdateQueryParams, config: Partial<RequestConfig<UserControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<UserControllerUpdateMutationResponse, ResponseErrorConfig<UserControllerUpdate400 | UserControllerUpdate401 | UserControllerUpdate403 | UserControllerUpdate404>, UserControllerUpdateMutationRequest>({ method : "PATCH", url : getUserControllerUpdateUrl(userId).url.toString(), params, data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}